import load from '#core/load';
import { ParticleCloudCanvas } from './particle-cloud-canvas';


const container_$ = '[data-particle-cloud]';
const layers_attr = 'data-particle-cloud-layers';
const debug_attr = 'data-particle-cloud-debug';
const field_$ = '.particle-cloud__field';
const replay_$ = '[data-particle-cloud-replay]';


/**
 * Resolve a CSS `var(--token)` color string to its computed value
 * by mounting a temporary element inside the given context.
 * Returns the input unchanged if it does not contain `var(`.
 * @param {string} value
 * @param {HTMLElement} $context
 * @return {string}
 */
function resolve_color(value, $context) {
	if (typeof value !== 'string' || !value.includes('var(')) return value;
	const $tmp = document.createElement('span');
	$tmp.style.color = value;
	$tmp.style.display = 'none';
	$context.appendChild($tmp);
	const resolved = getComputedStyle($tmp).color;
	$context.removeChild($tmp);
	return resolved;
}


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('particle-cloud')) return false;

		load.all(() => {
			const $containers = document.querySelectorAll(container_$);
			if (!$containers.length) return false;

			$containers.forEach($el => {
				const debug = $el.hasAttribute(debug_attr);
				const $field = $el.querySelector(field_$);
				const target = $field || $el;

				// Parse layers from JSON attribute
				let layers = [];
				const layersJson = $el.getAttribute(layers_attr);
				if (layersJson) {
					try {
						layers = JSON.parse(layersJson);
					} catch (e) {
						layers = [];
					}
				}

				if (!layers.length) return;

				// Each layer object carries `scale`, `color`, and any
				// LAYER_DEFAULTS override (camelCase) — forward them all so
				// per-layer tuning passes straight through to the canvas.
				const layerConfigs = layers.map(l => {
					const cfg = Object.assign({}, l);
					if (cfg.color) cfg.color = resolve_color(cfg.color, $el);
					if (cfg.scale != null) cfg.scale = Number(cfg.scale);
					return cfg;
				});

				$el._particleField = new ParticleCloudCanvas(target, layerConfigs, { debug });

				const $replay = $el.querySelector(replay_$);
				if ($replay) {
					$replay.addEventListener('click', () => {
						$el._particleField.reset();
					});
				}
			});
		});
	},

};

export default module;
module.init();
